// extracted by mini-css-extract-plugin
export default {"pageWrap":"bc-z","fullWidth":"cc-z","heading":"dc-z","fullBleed":"ec-z","hidden":"fc-z"};